import { render, staticRenderFns } from "./FormDetailInclude.vue?vue&type=template&id=3847db90&"
import script from "./FormDetailInclude.vue?vue&type=script&lang=js&"
export * from "./FormDetailInclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3847db90')) {
      api.createRecord('3847db90', component.options)
    } else {
      api.reload('3847db90', component.options)
    }
    module.hot.accept("./FormDetailInclude.vue?vue&type=template&id=3847db90&", function () {
      api.rerender('3847db90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/FormDetailInclude.vue"
export default component.exports